/* eslint-disable quotes */
/* eslint-disable semi */
export const storeActions = {
  // tiers
  // eslint-disable-next-line quotes
  loginAction: 'loginAction',
  forgotPassword: 'forgotPassword',
  resetPassword: 'resetPassword',
  isTokenValidForQentelli: 'isTokenValidForQentelli',
  createLicense: 'createLicense',
  getLicense: 'getLicense',
  updateLicenseByid: 'updateLicenseByid',
  getLicenseByid: 'getLicenseByid',
  getTierDetails: 'getTierDetails',
  getTierById: 'getTierById',
  getTierList: 'getTierList',
  addLicenseManager: 'addLicenseManager',
  getLicenseManagerDetails: 'getLicenseManagerDetails',
  getRoleList: 'getRoleList',
  getLicenseManagerById: 'getLicenseManagerById',
  updateLicenseManager: 'updateLicenseManager',
  userUpdate: 'userUpdate',
  getUserById: 'getUserById',
  // snackbar
  addTiers: 'addTiers',
  updateTier: 'updateTier',
  getProductList: 'getProductList',
  // snackbar
  getLicensesCount: 'getLicensesCount',
  getUserCount: 'getUserCount',
  getTierCount: 'getTierCount',
  // snackbar
  setSnackbarText: 'setSnackbarText',
  //changepassword
  changePassword:'changePassword',
  
  // Business Function
  createVsm: 'createVsm',
  getVsmList: 'getVsmList',
  getVsmById: 'getVsmById',
  updateVsmById: 'updateVsmById',
  // designations
  createDesignation: 'createDesignation',
  getDesignation: 'getDesignation',
  getDesignationById: 'getDesignationById',
  updateDesignationById: 'updateDesignationById',
  getDomainById: 'getDomainById',
  updateDomainById: 'updateDomainById',
  // domains
  createDomain: 'createDomain',
  getDomain: 'getDomain',
  // departments
  createDepartment: 'createDepartment',
  getDepartment: 'getDepartment',
  getDepartmentById: 'getDepartmentById',
  updateDepartmentById: 'updateDepartmentById',
  getCurrentUserDetails:'getCurrentUserDetails',
  updateCurrentUserDetails:'updateCurrentUserDetails',
  addVsmMetric: 'addVsmMetric',
  getVsms: 'getVsms',
  getVsmMetric: 'getVsmMetric',
  updateVsmMetric: 'updateVsmMetric',
  updateVsmMetricStatus: 'updateVsmMetricStatus',
  getCustomerList:'getCustomerList',
  getCustomerProfileById:'getCustomerProfileById',
  getListOfCustomers:'getListOfCustomers',
  //analytics
  getDemoPaidUsers: 'getDemoPaidUsers',
  getAgencyOwnUsers: 'getAgencyOwnUsers',
  getUsersList: 'getUsersList',
  addHtmlContent:'addHtmlContent',
  getDynamicUrls:'getDynamicUrls',
  createEndPoints:'createEndPoints',
  GetHTMLContent:'GetHTMLContent',
  getSignupData:'getSignupData',
  getDirectSignups:'getDirectSignups',
  getEarlyChurnRate:'getEarlyChurnRate',
  getPaidConversionRate:'getPaidConversionRate',
  getAvgUsers:'getAvgUsers',
  getMetricsCount:'getMetricsCount',
  getProgramsCount:'getProgramsCount',
  getVsmsCount:'getVsmsCount',
  getClientsCount:'getClientsCount',
  getConnectorsCount:'getConnectorsCount',
  getProjectsCount:'getProjectsCount',
  uploadImage:'uploadImage',
  getInvitedUsersCount:'getInvitedUsersCount'
};
